import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { RedirectComponent } from './features/auth/redirect.component';
import { TokenLoginComponent } from './features/auth/token-login.component';

export const routes: Routes = [
  { path: 'cuenta/login/:token', component: TokenLoginComponent },
  {
    path: ':id/main',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/app-shell.component').then(m => m.AppShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'marketplace' },
      {
        path: 'marketplace',
        loadComponent: () =>
          import('./features/marketplace/marketplace.component').then(m => m.MarketplaceComponent),
      },
      {
        path: 'marketplace/:appId',
        loadComponent: () =>
          import('./features/marketplace/aplicacion-detalle.component').then(
            m => m.AplicacionDetalleComponent
          ),
      },
      {
        path: 'payment-verify/:sessionId',
        loadComponent: () =>
          import('./features/marketplace/pago/payment-verify.component').then(
            m => m.PaymentVerifyComponent
          ),
      },
    ],
  },
  { path: '**', component: RedirectComponent },
];
